(function ($) {

var jQuery = $;

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

  
timber.init = function () {

  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  timber.Slideshow();  
  timber.Statistics(); 
  timber.Penrose();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  $parents.on('mouseover touchstart', function(evt) {
    var ret = true;
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
      ret = false;
    }

    showDropdown($el);
    return ret;
  });

  $parents.hoverIntent({
    over: function(evt) {
      $('.' + activeClass).each(function (el) {
        var $active = $(this);
        if ($active.has(evt.target).length === 0) {
          $active.removeClass(activeClass);
        }
      });
    },
    out: function() {

    }
  });

  // Mouseout
  $('#top_links_wrapper').on('mouseleave', function() {
    hideDropdown();
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    // Remove iOS workaround because it breaks menu z-index
    $('.sticky-header').removeClass('sticky-header-transformed');

    // Select if the submenu should appear left or right of the menu
    var $child = $el.parent().find('.site-nav__subdropdown');
    var childWidth = Math.max.apply(null, $child.map(function () { return $(this).width() }).get());
    var right = $el.offset().left + $el.outerWidth() + childWidth;

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function(evt) {
        if ($(evt.target).closest('.site-nav__link,.dropdown-submenu').length === 0) {
          // Hide dropdown if the touchstart was not on nav link
          hideDropdown($el);
        }
      });
    }, 250);
  }

  function hideDropdown ($el) {
    if ($el !== undefined) $el.removeClass(activeClass);
    else $('.site-nav--has-dropdown').removeClass(activeClass);
    timber.cache.$body.off('touchstart');

    // Reenable iOS workaround
    if ($('.nav-hover').length === 0) {
      $('.sticky-header').addClass('sticky-header-transformed');
    }
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
  
  $('.site-nav--second').on('mouseenter touchstart', function(){
    var $this = $(this),
    	$parent = $this.closest('.site-nav__dropdown');    
    
    $parent.find('.site-nav__subdropdown').removeClass('site-nav__subdropdown--active');
    $parent.find('.site-nav__subdropdown[data-id="'+ $this.data('id') +'"]').addClass('site-nav__subdropdown--active');
  });
  
  $('.site-nav--secondary').on('mouseenter touchstart', function(){    
    $('.site-nav--secondary').removeClass('active');
    $(this).addClass('active');      
  });
};

timber.drawersInit = function () {
  if (!timber.LeftDrawer) {
    timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  } else {
    timber.LeftDrawer.init();
  }
  if (!timber.RightDrawer) {
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      
    });
  } else {
    timber.RightDrawer.init();
  }
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.off('click').on('click', function(evt) {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      element = options.element;

  // Selectors
  var $productImage = element.find('#ProductPhotoImg'),
      $addToCart = element.find('#AddToCart'),
      $productPrice = element.find('#ProductPrice'),
      $comparePrice = element.find('#ComparePrice'),
      $addToCartText = element.find('#AddToCartText'),
      $variantPercentageWrapper = element.find('.variant-percentage-wrapper'),
      $variantValueWrapper = element.find('.variant-value-wrapper');

  if (variant) {

    
    var pid = element.find("#wpdPid").val();

    var WCP_JSON=[];
      if($('.wcp_json_'+pid).length){    
            WCP_JSON=JSON.parse($('.wcp_json_'+pid)[0].innerText);
        $.each(WCP_JSON.variants, function( index, value ) {
            if(variant.id == value.id){
                variant.price = value.price;  
                variant.compare_at_price = value.compare_at_price;       
             return ;
            }
        });      
    } 
    
    if(document.getElementsByClassName('wcp_vd_table').length!=0 && document.getElementById("vdtable") !=null){
	
        var source = document.getElementById("vdtable").innerHTML;
        var template = Handlebars.compile(source);
   		 if(document.getElementsByClassName('wcp_vd_table')[0] != undefined && document.getElementsByClassName('wcp_vd_table')[0].innerText != ""){
        var context = JSON.parse(document.getElementsByClassName('wcp_vd_table')[0].innerText);      
        var vdtable=[];
        vdtable['vdtable'] = context['wpd_'+variant.id];
        var html = template(vdtable);  		
        document.getElementById("wcp_vd_table").innerHTML = html;
        }
        else
        {
        document.getElementById("wcp_vd_table").innerHTML = "";
        }

		}
    
    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      window.wetheme.load_SPB_show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Out of stock");
      window.wetheme.load_SPB_hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html('<span class="money">' + Shopify.formatMoney(variant.price, moneyFormat) + '</span>');

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</span>')
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
  }

  // Update discount badge
  var isSale = variant && variant.compare_at_price > variant.price;
  if ($variantPercentageWrapper.length > 0) {
    if (isSale) {
      $variantPercentageWrapper.removeClass('hide');
      var percentage = (variant.compare_at_price - variant.price) * 100.0 / variant.compare_at_price;
      $variantPercentageWrapper.find('.variant-percentage').text(percentage.toFixed(0) + '%');
    } else {
      $variantPercentageWrapper.addClass('hide');
    }
  }
  if ($variantValueWrapper.length > 0) {
    if (isSale) {
      $variantValueWrapper.removeClass('hide');
      var value = variant.compare_at_price - variant.price;
      $variantValueWrapper.find('.variant-value')
        .html('<span class="money">' + Shopify.formatMoney(value, moneyFormat) + '</span>')
    } else {
      $variantValueWrapper.addClass('hide');
    }
  }
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    if($(this).parents('.hero-video').length > 0) return;
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

timber.addToCartAdding = function() {
  $addToCart = $('#AddToCart');
  var CART_LOADING = '<i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i><span class="sr-only">Loading...</span>';
  $('#AddToCart').addClass('disabled').prop('disabled', true).html(CART_LOADING);
}

timber.addToCartAdded = function() {
  var added_text_timeout = null;
  $addToCart = $('#AddToCart');

  $addToCart.html("Added");

  if (added_text_timeout) {
    clearTimeout(added_text_timeout);
    added_text_timeout = null;
  }
  added_text_timeout = setTimeout(function () {
      $addToCart.removeClass('disabled').prop('disabled', false).html("Add to Cart");
  }.bind(this), 2000);

}


/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position + '-link',
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    var self = this;
    $(this.config.open).off('click').on('click', function (evt) { self.open(evt); });
    this.$drawer.find(this.config.close).off('click').on('click', this.close.bind(this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();
  
  timber.slideshows = {};

  timber.Slideshow = (function() {
    function Slideshow(container) {
      this.$container = $(container);
      var sectionId = this.$container.attr('data-section-id');
      this.slideshow = '#Slideshow-' + 'custom-slideshow';

      timber.slideshows[this.slideshow] = new timber.Hero(this.slideshow);
    }

    Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
      onUnload: function() {
        timber.slideshows[this.slideshow].destroy();
      },

      onSelect: function() {
        timber.slideshows[this.slideshow].pause();
        timber.Notify.adaptNotification();
      },

      onDeselect: function() {
        timber.slideshows[this.slideshow].play();
      },

      onBlockSelect: function(evt) {
        var $slide = $(
          '.hero__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
        );
        var slideIndex = $slide.data('slick-index');

        timber.slideshows[this.slideshow].pause();
        timber.slideshows[this.slideshow].goToSlide(slideIndex);
      },

      onBlockDeselect: function() {
        timber.slideshows[this.slideshow].play();
      }
    });

    return Slideshow;
  })();

  timber.Hero = (function() {
    var selectors = {
      hero: '.hero',
      heroWrapper: '.hero-wrapper',
      heroContent: '.hero-content',
      heroTitle: '.hero-content__title',
      heroPause: '.hero__pause',
      heroAdapt: '.hero--adapt',
      heroControlsArrow: '.hero-content__controls-item--arrow',
      heroControlsCount: '.hero-content__controls-item--count',
      heroControlsText: '.hero-content__controls-item--text'
    };

    var classes = {
      heroContentActive: 'hero-content-active',
      heroTitleActive: 'hero-title-active',
      heroLinkActive: 'hero-link-active',
      isPaused: 'is-paused'
    };

    function Hero(sectionId) {
      this.namespace = '.hero';
      this.$hero = $(sectionId);
      this.$wrapper = this.$hero.closest(selectors.heroWrapper);
      this.$heroContent = this.$wrapper.find(selectors.heroContent);
      this.$heroPause = this.$wrapper.find(selectors.heroPause);
      this.$heroControlsArrow = this.$wrapper.find(selectors.heroControlsArrow);
      this.$heroAdapt = this.$wrapper.find(selectors.heroAdapt);

      this.$hero.on('init' + this.namespace, this._a11y.bind(this));
      this.$hero.on('init' + this.namespace, this._arrowsInit.bind(this));
      this.$hero.on(
        'init reInit afterChange' + this.namespace,
        this._countSlide.bind(this)
      );
      this.$hero.on(
        'init reInit afterChange' + this.namespace,
        this._showActiveContent.bind(this)
      );
      this.$hero.on(
        'init reInit afterChange' + this.namespace,
        this._showContent.bind(this)
      );
      this.$hero.on(
        'beforeChange' + this.namespace,
        this._hideContent.bind(this)
      );

      var adaptHeight = this.$hero.data('adapt-height');

      this.$hero.slick({
        accessibility: true,
        arrows: false, // this theme has custom arrows
        draggable: false,
        autoplay: this.$hero.data('autoplay'),
        autoplaySpeed: this.$hero.data('speed')
      });

      if (adaptHeight) {
        this._setSlideshowHeight();
        $(window).resize($.debounce(50, this._setSlideshowHeight.bind(this)));
      }

      this.$heroPause.on('click' + this.namespace, this._togglePause.bind(this));
    }

    Hero.prototype = _.assignIn({}, Hero.prototype, {
      _setSlideshowHeight: function() {
        var minAspectRatio = this.$hero.data('min-aspect-ratio');
        this.$hero.height(this.$heroAdapt.width() / minAspectRatio);
      },

      _countSlide: function(event, slick, currentSlide) {
        // currentSlide is undefined on init,
        // set it to 0 in this case (currentSlide is 0 based)
        var activeSlide = (currentSlide ? currentSlide : 0) + 1;
        var $heroControlsCount = this.$wrapper.find(selectors.heroControlsCount);

        if (slick.slideCount > 1) {
          $heroControlsCount.attr(
            'aria-label',
            'Slide '+ activeSlide + ', current'
          );
          $heroControlsCount
          .children('.slide-counter')
          .text(activeSlide + '/' + slick.slideCount);
        }
      },

      _showActiveContent: function(event, slick, currentSlide) {
        // currentSlide is undefined on init,
        // set it to 0 in this case (currentSlide is 0 based)
        // eslint-disable-next-line
        var currentSlide = currentSlide || 0;
        var $heroControlsText = this.$wrapper.find(selectors.heroControlsText);
        var $heroTitle = this.$wrapper.find(selectors.heroTitle);

        if (slick.slideCount > 1) {
          var $currentTitle = $heroTitle.filter(
            '[data-slide-id="' + (currentSlide + 1) + '"]'
          ),
              $currentLink = $heroControlsText.filter(
                '[data-slide-id="' + (currentSlide + 1) + '"]'
              );

          $heroTitle.removeClass(classes.heroTitleActive);
          $currentTitle.addClass(classes.heroTitleActive);
          $heroControlsText.removeClass(classes.heroLinkActive);
          $currentLink.addClass(classes.heroLinkActive);
        }
      },

      _hideContent: function() {
        this.$heroContent.removeClass(classes.heroContentActive);
      },

      _showContent: function() {
        this.$heroContent.addClass(classes.heroContentActive);
      },

      _togglePause: function() {
        if (this.$heroPause.hasClass(classes.isPaused)) {
          var labelPause = this.$heroPause.data('label-pause');
          this.$heroPause.removeClass(classes.isPaused).attr({
            'aria-pressed': 'false',
            'aria-label': labelPause
          });
          this.play();
        } else {
          var labelPlay = this.$heroPause.data('label-play');
          this.$heroPause.addClass(classes.isPaused).attr({
            'aria-pressed': 'true',
            'aria-label': labelPlay
          });
          this.pause();
        }
      },

      _a11y: function(event, obj) {
        var $list = obj.$list;
        var $heroWrapper = $(event.currentTarget).parents(selectors.heroWrapper);
        var autoplay = this.$hero.data('autoplay');

        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
        this.$heroContent.removeAttr('aria-live');

        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $heroWrapper
        .on(
          'focusin' + this.namespace,
          function(evt) {
            if (!$heroWrapper.has(evt.target).length) {
              return;
            }

            this.$heroContent.attr('aria-live', 'polite');
            if (autoplay) {
              this.pause();
            }
          }.bind(this)
        )
        .on(
          // Resume autoplay
          'focusout' + this.namespace,
          function(evt) {
            if ($heroWrapper.has(evt.relatedTarget).length) {
              return;
            }

            this.$heroContent.removeAttr('aria-live');

            if (autoplay && !this.$heroPause.hasClass(classes.isPaused)) {
              // Only resume playing if the user hasn't paused using the pause
              // button
              this.play();
            }
          }.bind(this)
        )
        .on('keyup', this._keyboardNavigation.bind(this));
      },

      _arrowsInit: function(event, obj) {
        // Slider is initialized. Setup custom arrows
        var count = obj.slideCount;
        var $slider = obj.$slider;
        var $arrows = this.$heroControlsArrow;

        if ($arrows.length && count > 1) {
          $arrows.on(
            'click' + this.namespace,
            function(evt) {
              evt.preventDefault();
              var $arrowButton = $(evt.currentTarget).find('button');
              var arrowButtonControl = $arrowButton.data('control');
              if (arrowButtonControl === 'previous') {
                $slider.slick('slickPrev');
              } else if (arrowButtonControl === 'next') {
                $slider.slick('slickNext');
              }
              this._scrollTop();
            }.bind(this)
          );
        } else {
          $arrows.remove();
        }
      },

      _scrollTop: function() {
        var currentScroll = $(document).scrollTop();
        var heroOffset = this.$hero.offset().top;

        if (currentScroll > heroOffset) {
          $('html')
          .add('body')
          .animate(
            {
              scrollTop: heroOffset
            },
            250
          );
        }
      },

      _keyboardNavigation: function(event) {
        if (event.keyCode === 37) {
          this.$hero.slick('slickPrev');
        }
        if (event.keyCode === 39) {
          this.$hero.slick('slickNext');
        }
      },

      goToSlide: function(slideIndex) {
        this.$hero.slick('slickGoTo', slideIndex);
      },

      pause: function() {
        if (!this.$hero.data('autoplay')) return;
        this.$hero.slick('slickPause');
      },

      play: function() {
        if (!this.$hero.data('autoplay')) return;
        this.$hero.slick('slickPlay');
      },

      destroy: function() {
        this.$hero.off(this.namespace);
        this.$heroContent.off(this.namespace);
        this.$heroPause.off(this.namespace);
        this.$wrapper.off(this.namespace);
        this.$heroControlsArrow.off(this.namespace);
        this.$heroAdapt.off(this.namespace);

        this.$hero.slick('unslick');
      }
    });

    return Hero;
  })(); 


  timber.Statistics = (function(){
    var observer,
        config = { attributes: true };
    
    function callback(mutationsList, observer) {
      for(var mutation in mutationsList) {
        var thisMutation = mutationsList[mutation];
        
        if (thisMutation.attributeName === 'class') {
          
          $(thisMutation.target).find('.statistics__stat').each(function() {
          	$(this).find('.odometer').html($(this).data('stat'));
          });
        }
      }
    }
    
	observer = new MutationObserver(callback);
    
    function Statistics(){
      $('.statistics').each(function(){
      	observer.observe($(this)[0], config);
      });      
    }
    
    return Statistics;
  })();

  timber.brands = (function(){
    var $brands = jQuery('.brand'),
        $anchors = jQuery('#anchor-links'),
        $brandPicker = jQuery('.brand-picker');

    $brands.each(function(){
      var $this = jQuery(this),
          disabledClass = $this.find('.brand-block').length ? '' : ' anchor--disabled';

      if($this.find('.brand-block').length) {
        $anchors.append('<a class="anchor' + disabledClass + '" href="#'+ $this.attr('id') + '">' + $this.data('brand') + '</a>');
        $brandPicker.append('<option value="#' + $this.attr('id') + '">' + $this.data('brand') + '</option>');
      } else {
        $anchors.append('<p class="anchor' + disabledClass + '">' + $this.data('brand') + '</p>');
      }

    });

    $anchors.on('click', '.anchor', function(e) {
      e.preventDefault();
      var scrollTop = jQuery(jQuery(this).attr('href')).offset().top;

      jQuery('html, body').animate({
        scrollTop: scrollTop - 100
      }, 500);
    });
    
    $brandPicker.on('change', function(){
      var scrollTop = jQuery(jQuery(this).val()).offset().top;

      jQuery('html, body').animate({
        scrollTop: scrollTop - 100
      }, 500);
    });
  })();
  
  timber.Penrose = (function() {

    function Penrose(){
      var $section = $('#penrose-animation');
            
      $section.find('.accent').on({
        mouseenter: function() {
          if($(this).hasClass('inactive')) {
           return; 
          }
             
          $(this).closest('svg').find('g').not($(this)).addClass('opacity');
          $(this).removeClass('opacity');
        },
        click: function() {
          var card = '.' + $(this).data('section');
          
          if($(this).hasClass('active') || !$section.find(card).length) {
           return; 
          }          
          
          $(this).closest('svg').find('g').not($(this)).addClass('inactive').removeClass('active');
          $(this).addClass('active').removeClass('inactive');
          
          $section.find('.penrose-card').hide();                    
          $section.find('.penrose__intro').hide();
          $section.find(card).stop().fadeIn();
        },
        mouseleave: function() {
          $(this).closest('svg').find('g').not($(this)).removeClass('opacity');          
        }
      });
      
      $section.find('.penrose__close').on('click', function(){
        $section.find('svg').find('g').removeClass('inactive active');
      	$section.find('.penrose-card').hide();
        $section.find('.penrose__intro').stop().fadeIn();
      });
      
      $section.find('.penrose__select').on('change', function(){
      	var card = '.' + $(this).val();
        
        if(!$section.find(card).length) {
          $section.find('.penrose-card').hide();
          $section.find('.penrose__intro').stop().fadeIn();
          return;
        }
        
        $section.find('.penrose-card').hide();                    
        $section.find('.penrose__intro').hide();
        $section.find(card).stop().fadeIn();
      });
    }

    return Penrose;
  })();
  

// Initialize Timber's JS on docready
$(timber.init);
document.addEventListener('shopify:section:load', timber.init);

})(window.wetheme.$);


